import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import PropTypes from 'prop-types';

import AutosuggestInput from 'components/autosuggestInput';
import ZpButton from 'components/zpButton';
import { importStatic } from 'utils';

import classes from './index.module.css';

const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  autosuggestCategory: PropTypes.oneOf([
    'jobTitle',
    'location',
    'major',
    'company',
    'department',
    'locationExtended',
  ]),
  autosuggestPlaceholder: PropTypes.string,
  autosuggestPrefillValue: PropTypes.string,
  onAutosuggestChange: PropTypes.func,
  onAutosuggestFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  searchBtnContent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

const defaultProps = {
  title: '',
  subtitle: '',
  autosuggestCategory: 'location',
  autosuggestPrefillValue: '',
  autosuggestPlaceholder: '',
  onAutosuggestChange: () => null,
  onAutosuggestFocus: () => null,
  onSubmit: () => null,
  searchBtnContent: <ReactSVG src={importStatic('/ui-router/images/job-search-input-icon.svg')} />,
};

const GrayAutosuggestBox = (props) => {
  const {
    title,
    subtitle,
    autosuggestCategory,
    autosuggestPlaceholder,
    autosuggestPrefillValue,
    onAutosuggestChange,
    onAutosuggestFocus,
    onSubmit,
    searchBtnContent,
  } = props;

  const [errorMessage, setErrorMessage] = useState(null);

  const handleAutosuggestError = (errorObject) => {
    setErrorMessage(errorObject.errorMessage);
  };

  const _onSubmit = (e) => {
    e.preventDefault();
    if (errorMessage) {
      return;
    }
    onSubmit();
  };

  return (
    <div className={`gray-autosuggest-box ${classes['gray-autosuggest-box']}`}>
      {title && <div className={classes['gray-autosuggest-title']}>{title}</div>}
      {subtitle && <div className={classes['gray-autosuggest-subtitle']}>{subtitle}</div>}
      <div className={classes['gray-autosuggest-form']}>
        <AutosuggestInput
          initWithCriteria
          category={autosuggestCategory}
          inputProps={{
            placeholder: autosuggestPlaceholder,
            className: classes['gray-autosuggest-input'],
          }}
          prefillValue={autosuggestPrefillValue}
          onChange={onAutosuggestChange}
          onFocus={onAutosuggestFocus}
          onErrorCallback={handleAutosuggestError}
          onEnterKeyDown={_onSubmit}
        />
        <ZpButton
          theme="primary"
          size="big"
          type="button"
          staticWidth={34}
          onClick={_onSubmit}
          className={classes['gray-autosuggest-btn']}
        >
          {searchBtnContent}
        </ZpButton>
      </div>
      {errorMessage && (
        <div className="error-message gray-autosuggest-box-error">{errorMessage}</div>
      )}
    </div>
  );
};

GrayAutosuggestBox.defaultProps = defaultProps;
GrayAutosuggestBox.propTypes = propTypes;

export default GrayAutosuggestBox;
